document.addEventListener("DOMContentLoaded", function () {
  var sliders = document.querySelectorAll(
    ".picasso-testimonial .shout-out-slider"
  );

  sliders.forEach(function (slider) {
    var flktyShotoutSlider = new Flickity(slider, {
      wrapAround: false,
      fade: true,
      prevNextButtons: false,
      pageDots: false,
      adaptiveHeight: true,
      draggable: true,
      on: {
        change: function (index) {
          console.log("Flickity changed");

          // Use the slider element as the scope for selecting dots
          var dots = slider.querySelectorAll(".dot");
          dots.forEach((dot) => dot.classList.remove("active"));

          var activeDot = slider.querySelectorAll(".dot-" + index);
          if (activeDot) {
            activeDot.forEach((dot) => dot.classList.add("active"));
          }

          var item_length =
            slider.querySelectorAll(
              ".testimonial-wrapper .flickity-slider-wrapper"
            ).length - 1;
          var prevButton = slider.querySelector(".bprev_s");
          var nextButton = slider.querySelector(".bnext_s");

          if (index === item_length) {
            prevButton.classList.remove("disabled");
            nextButton.classList.add("disabled");
          } else if (index === 0) {
            prevButton.classList.add("disabled");
            nextButton.classList.remove("disabled");
          } else {
            prevButton.classList.remove("disabled");
            nextButton.classList.remove("disabled");
          }
          var item_length =
            slider.querySelectorAll(
              ".testimonial-wrapper .flickity-slider-wrapper"
            ).length - 1;
          var prevButtons = slider.querySelectorAll(".bprev_s");
          var nextButtons = slider.querySelectorAll(".bnext_s");

          if (index === item_length) {
            prevButtons.forEach((button) =>
              button.classList.remove("disabled")
            );
            nextButtons.forEach((button) => button.classList.add("disabled"));
          } else if (index === 0) {
            prevButtons.forEach((button) => button.classList.add("disabled"));
            nextButtons.forEach((button) =>
              button.classList.remove("disabled")
            );
          } else {
            prevButtons.forEach((button) =>
              button.classList.remove("disabled")
            );
            nextButtons.forEach((button) =>
              button.classList.remove("disabled")
            );
          }
        },
      },
    });

    window.addEventListener(
      "resize",
      function (event) {
        flktyShotoutSlider.resize();
      },
      true
    );

    // Navigation button click handlers
    var nextButtons = slider.querySelectorAll(".navigation .bnext_s");
    nextButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        if (!this.classList.contains("disabled")) {
          flktyShotoutSlider.next(false, false);
        }
      });
    });

    var prevButtons = slider.querySelectorAll(".navigation .bprev_s");
    prevButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        if (!this.classList.contains("disabled")) {
          flktyShotoutSlider.previous(false, false);
        }
      });
    });
  });
});
